<div id="it-to-account-container" class="row big-bottom-spacer" [formGroup]="parentForm">
  <div id="to-account-number" class="column-1">
    <label [class.error-text]="toAccountFormIsInvalid">{{labelName}}</label>
    <input id="it-to-account-number" data-testid="it-to-account-number" name="account-number"
      class="sdps-input sdps-input--small" [class.error-input]="toAccountFormIsInvalid"
      type="text" formControlName="toAccount"
      (keydown)="validationService.validateNumberInput($event, toAccountAllowedChars)"
      (keydown.enter)="onSubmit()" (blur)="onSubmit()" (input)="onInput()"/>
    <i *ngIf="toAccount.valid && !isToAccountInContext && !disabled" class="sch-search"></i>
    <i data-testid="clearAccountIcon" *ngIf="isToAccountInContext && !disabled" (click)="clearToAccountClicked()" class="sch-thin-x"></i>
    <div *ngIf="toAccountFormIsInvalid" class="alert-text" data-testid="to-account-alert">
      {{ toAccountValidationError }}
    </div>
  </div>
  <div id="acccount-registration" class="column-2">
    <div *ngIf="(toAccountState$ | async)?.loading && !disabled" class="spinner-container">
      <mm-spinner [loading]="toAccountState$"></mm-spinner>
    </div>
    <div class="registration-details" *ngIf="showAccountRegDetails" data-testid="account-registration-data">
      <span id="account-registration-header">Account registration</span>
      <span *ngFor="let regLine of receivingAccountDetails" [ngClass]="{ 'reg-details-line': !hasAccountRegDetails}">{{regLine}}</span>
    </div>
  </div>
</div>
